import html2canvas from 'html2canvas';

// html2canvas serializes SVG roots as images. Leaflet's root CSS transform
// must position that image only once, not also transform its internal drawing.
export function flattenMapVectors(container) {
  for (const svg of container.querySelectorAll('.leaflet-pane > svg')) {
    const drawing = svg.cloneNode(true);
    drawing.removeAttribute('style');
    drawing.removeAttribute('class');
    const image = container.ownerDocument.createElement('img');
    image.className = svg.getAttribute('class') || '';
    image.style.cssText = svg.style.cssText;
    image.style.position = 'absolute';
    image.style.width = `${svg.getAttribute('width')}px`;
    image.style.height = `${svg.getAttribute('height')}px`;
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(drawing))}`;
    svg.replaceWith(image);
  }
}

export async function captureReportMap(map) {
  if (!map) throw new Error('The location overview is not ready yet.');
  map.closePopup();
  const container = map.getContainer();
  const started = Date.now();
  // Leaflet and GeoTIFF both expose pending tiles through GridLayer.isLoading().
  while (true) {
    let loading = false;
    map.eachLayer(layer => { if (layer.isLoading?.()) loading = true; });
    const images = [...container.querySelectorAll('img')];
    if (!loading && images.every(img => img.complete)) {
      if (images.some(img => !img.naturalWidth)) throw new Error('Some map imagery failed to load. Reload the map before generating the report.');
      break;
    }
    if (Date.now() - started > 30000) throw new Error('The map is still loading. Wait for the imagery and try again.');
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const canvas = await html2canvas(container, {
    useCORS: true, allowTaint: false, backgroundColor: '#ffffff', scale: 2,
    logging: false, imageTimeout: 30000,
    onclone: (_document, clonedContainer) => flattenMapVectors(clonedContainer),
    ignoreElements: element => element.classList?.contains('leaflet-control-zoom') || element.classList?.contains('leaflet-popup-pane'),
  });
  return canvas.toDataURL('image/jpeg', .9);
}
